import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StepperProps {
  steps: string[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}

const Stepper: React.FC<StepperProps> = ({ 
  steps, 
  currentStep, 
  onStepClick 
}) => {
  return (
    <div className="w-full py-2">
      <div className="flex items-center justify-between relative">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isFirst = index === 0;
          const isLast = index === steps.length - 1;
          
          return (
            <div key={index} className="flex-1 flex flex-col items-center max-w-[180px] min-w-[80px]">
              <div className="w-full flex items-center justify-center relative">
                {/* Single connecting line to the next step */}
                {!isLast && (
                  <div 
                    className={cn(
                      "absolute left-1/2 w-full h-0.5 transition-colors",
                      index < currentStep ? "bg-primary" : "bg-muted-foreground/30"
                    )}
                  />
                )}
                
                {/* Step circle */}
                <button
                  type="button"
                  onClick={() => onStepClick && onStepClick(index)}
                  disabled={!onStepClick || index > currentStep}
                  className={cn(
                    "relative z-10 flex h-8 w-8 items-center justify-center rounded-full transition-all",
                    isCompleted ? "bg-primary text-primary-foreground" : 
                    isCurrent ? "border-2 border-primary bg-[hsl(25.44,52.72%,90.32%)] text-primary" : 
                    "border-2 border-muted-foreground/30 bg-[hsl(25.44,52.72%,90.32%)] text-muted-foreground",
                    onStepClick && index <= currentStep ? "cursor-pointer" : "cursor-default"
                  )}
                >
                  {isCompleted ? (
                    <Check className="h-4 w-4" />
                  ) : (
                    <span className="text-sm font-medium">{index + 1}</span>
                  )}
                </button>
              </div>
              
              {/* Step label */}
              <span 
                className={cn(
                  "text-xs mt-2 text-center w-full px-1",
                  index === currentStep ? "text-primary font-semibold" : "text-muted-foreground"
                )}
              >
                {step}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
